// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"VNUm2y","input":"eUENnX"};